export default function* logActionsWatcher() {
    // yield all([takeEvery("*", logActions)]);
}
